export default {
    methods:{
        message2parent(type, data){
            window.parent.postMessage({type,data}, "*");
        },
        messageHandler(event){
            if(event.origin !== document.location.origin) return;
            try{
                if(event.data.type && this['message_'+event.data.type]){
                    this['message_'+event.data.type](event.data.data);
                }
            }catch(e){}
        }
    },
    created() {
        // this.$options.windowEvents = this.$options.windowEvents || {}
        window.addEventListener('message', this.messageHandler, false)
    },
    beforeDestroy(){
        window.removeEventListener('message', this.messageHandler)
    }
}